export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const identifySelectedRequestType = (arraySubtypes, dataToSearch) => {
        const foundValue = arraySubtypes.find(item => item.idgestiontipo === dataToSearch)

        return (foundValue)? foundValue.prefijo : 'No se ha seleccionado nada'
    }

    const getBodyForDateChange = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_nuevo_dia_pago: FormRequestGlobal.formState.gestion_nuevo_dia_pago,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForTotalInsurancePayment = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_total_seguro: convertToFloat(FormRequestGlobal.formState.total_seguro),
            check_seguro: (FormRequestGlobal.formState.check_seguro) ? 1 : 0,
            fecha_fin_contrato: FormRequestGlobal.formState.fecha_fin_contrato,
            gestion_cuota_seguro: parseFloat(String(FormRequestGlobal.formState.seguro).replace(/,/g, "")) || 0,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForGPSRemoval = ({user, FormRequestGlobal, isForUpdate}) => {

        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';
        
        return {
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getBodyForContractTermination = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForUncollectibleAccounts = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';
        
        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idusuario: user.uid,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForGPSExemption = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';
        
        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idusuario: user.uid,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: 'Pendiente Aprobacion',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForExtraordinaryTermination= ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            idusuario: user.uid,
            total_negociado: FormRequestGlobal.formState.clean_total_negociado,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            fecha_gestion: FormRequestGlobal.formState.fecha_gestion,
            aprobacion_check: 'Pendiente Aprobacion',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getBodyForCreditRefinancion= ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            idusuario: user.uid,

            saldo_financiado: FormRequestGlobal.formState.clean_saldo_financiado,
            interes: FormRequestGlobal.formState.interes,
            plazo: FormRequestGlobal.formState.nuevo_plazo,
            gps: FormRequestGlobal.formState.clean_gps,
            seguro: FormRequestGlobal.formState.clean_seguro,
            otros: FormRequestGlobal.formState.clean_otros,
            cuota_niv: FormRequestGlobal.formState.clean_nuevo_cuota_niv,
            gestion_nuevo_dia_pago: FormRequestGlobal.formState.gestion_nuevo_dia_pago,


            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            aprobacion_check: 'Pendiente Aprobacion',
            aprobacion_fecha : currentDate,
            
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getBodyForJudicialCollection = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            idusuario: user.uid,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            fecha_gestion: FormRequestGlobal.formState.fecha_gestion,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getBodyForBadDebts = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            idusuario: user.uid,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            fecha_gestion: FormRequestGlobal.formState.fecha_gestion,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getBodyForTerminationCreditLegal= ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcredito: FormRequestGlobal.formState.idcredito,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            idusuario: user.uid,
            total_negociado: FormRequestGlobal.formState.clean_total_negociado,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            fecha_gestion: FormRequestGlobal.formState.fecha_gestion,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const paymentCalculation = (monto_venta, monto_enganche, interes, plazo) => {

        // console.log(monto_venta, monto_enganche, interes, plazo);
        
        const interes_parse = (interes/100);
        const saldo_financiar = ((monto_venta - monto_enganche) * interes_parse)
        const cuota_niv = saldo_financiar / (1 - Math.pow(1 + interes_parse, -plazo));
        const cuota_niv_format = cuota_niv.toFixed(2) 
        return isNaN(cuota_niv_format) ? 0 : cuota_niv_format
      
    }

    const convertToFloat = (formattedNumber) => {
        const cleanedValue = formattedNumber.replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);
        return isNaN(floatValue) ? 0 : floatValue; // Retorna 0 si no es un número válido
    };

    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });


    
    return Object.freeze({
        identifySelectedRequestType,
        getCurrentDate,
        getBodyForDateChange,
        getBodyForTotalInsurancePayment,
        getBodyForGPSRemoval,
        getBodyForContractTermination,
        getBodyForUncollectibleAccounts,
        convertToFloat,
        getBodyForGPSExemption,
        getBodyForExtraordinaryTermination,
        getBodyForCreditRefinancion,
        getBodyForJudicialCollection,
        getBodyForBadDebts,
        getBodyForTerminationCreditLegal,
        paymentCalculation,
        numberFormatter
    })
}